<template>
  <div v-if="isVisible" class="preloader">
    <div class="terminal">
      <p class="typewriter">{{ text }}</p>
      <span class="cursor">_</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "ThePreloader",
  data() {
    return {
      isVisible: true,
      text: "",
      fullText: "INITIALIZING SECURE CONNECTION... ACCESS GRANTED.",
      index: 0,
    };
  },
  mounted() {
    this.type();
  },
  methods: {
    type() {
      if (this.index < this.fullText.length) {
        this.text += this.fullText.charAt(this.index);
        this.index++;
        setTimeout(this.type, 50);
      } else {
        setTimeout(() => {
          this.isVisible = false;
        }, 800);
      }
    },
  },
};
</script>

<style scoped>
.preloader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: var(--bg-primary);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
  animation: fadeOut 0.5s ease 3s forwards;
}

.terminal {
  font-family: var(--font-mono);
  color: var(--accent-neon);
  font-size: 24px;
  display: flex;
  align-items: center;
  text-shadow: 0 0 10px rgba(0, 240, 255, 0.5);
}

.typewriter {
  margin: 0;
}

.cursor {
  animation: blink 1s infinite;
  margin-left: 5px;
}

@keyframes blink {

  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0;
  }
}

@keyframes fadeOut {
  to {
    opacity: 0;
    visibility: hidden;
  }
}

@media (max-width: 768px) {
  .terminal {
    font-size: 16px;
    padding: 20px;
    text-align: center;
  }
}
</style>
